module.exports = __webpack_public_path__ + "img/m-caiwubaobiao.dc96f0c5.svg";